import { push } from "connected-react-router";
import React from "react";
import { useDispatch } from "react-redux";
import { ROUTE_PATH } from "../../app/constants";
import {
  Header,
  Paragraph,
  NavigationLinkButton,
} from "../../components/RegularComponents";
// import { setMortgageProperty } from "../../redux/slice/primaryAgencyApplicationSlice";

export const MraPricipleBrokerIneligible = (props) => {
  const dispatch = useDispatch();

  return (
    <div className="container">
      {/* Title */}
      <div className="row">
        <div className="col-xs-12 col-lg-10">
          <Header
            style={{ paddingBottom: "30px" }}
            id="principal-broker-ineligible-header"
            header=" Based on the information you provided, you aren't eligible to be the pricipal broker for your brokerage."
          />
        </div>
      </div>

      <div className="row">
        <div style={{paddingBottom:"20px"}} className="col-xs-12 col-lg-9">
          Review the
          <NavigationLinkButton
            id={"principal-broker-requirements-link"}
            text={"requirements for a principal broker"}
            onClick={() => {
              dispatch(
                push({
                  pathname: `${ROUTE_PATH.MRA_APP}`,
                })
              );
            }}
          />
        </div>
      </div>

      <div className="row">
        <div className="col-xs-12">
          <Paragraph
            style={{ paddingBottom: "20px" }}
            id="principal-broker-ineligible-header"
            text={[
              "To get help with assigning a new principal broker, contact techical support at 902-xxx-xxxx or onlinehelp@novascotia.ca",
            ]}
          />
        </div>
      </div>

      <div className="row">
        <div style={{marginLeft: "-5px"}} className="col-xs-12 col-lg-8">
          <NavigationLinkButton
            id={"cancel-quick-link"}
            text={"Cancel application and return home"}
            onClick={() => {
              dispatch(
                push({
                  pathname: `${ROUTE_PATH.MRA_APP}`,
                })
              );
            }}
          />
        </div>
      </div>
    </div>
  );
};
